module.exports = __webpack_public_path__ + "static/media/thief.a7e78647.jpg";